// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HintPlanDebugQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  workbookId: Types.Scalars["ID"]["input"];
  queryText: Types.Scalars["String"]["input"];
  hintPlan: Types.Scalars["String"]["input"];
}>;

export type HintPlanDebugQuery = {
  __typename?: "GraphqlQuery";
  getQueryHintPlanDebug: {
    __typename?: "HintPlanDebug";
    usedHints: Array<string>;
    notUsedHints: Array<string>;
    duplicationHints: Array<string>;
    errorHints: Array<string>;
    error?: string | null;
  };
};

export const HintPlanDebugDocument = gql`
  query HintPlanDebug(
    $databaseId: ID!
    $workbookId: ID!
    $queryText: String!
    $hintPlan: String!
  ) {
    getQueryHintPlanDebug(
      databaseId: $databaseId
      workbookId: $workbookId
      queryText: $queryText
      hintPlan: $hintPlan
    ) {
      usedHints
      notUsedHints
      duplicationHints
      errorHints
      error
    }
  }
`;

/**
 * __useHintPlanDebugQuery__
 *
 * To run a query within a React component, call `useHintPlanDebugQuery` and pass it any options that fit your needs.
 * When your component renders, `useHintPlanDebugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHintPlanDebugQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      workbookId: // value for 'workbookId'
 *      queryText: // value for 'queryText'
 *      hintPlan: // value for 'hintPlan'
 *   },
 * });
 */
export function useHintPlanDebugQuery(
  baseOptions: Apollo.QueryHookOptions<
    HintPlanDebugQuery,
    HintPlanDebugQueryVariables
  > &
    (
      | { variables: HintPlanDebugQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HintPlanDebugQuery, HintPlanDebugQueryVariables>(
    HintPlanDebugDocument,
    options,
  );
}
export function useHintPlanDebugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HintPlanDebugQuery,
    HintPlanDebugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HintPlanDebugQuery, HintPlanDebugQueryVariables>(
    HintPlanDebugDocument,
    options,
  );
}
// @ts-ignore
export function useHintPlanDebugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HintPlanDebugQuery,
    HintPlanDebugQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  HintPlanDebugQuery,
  HintPlanDebugQueryVariables
>;
export function useHintPlanDebugSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HintPlanDebugQuery,
        HintPlanDebugQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HintPlanDebugQuery | undefined,
  HintPlanDebugQueryVariables
>;
export function useHintPlanDebugSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HintPlanDebugQuery,
        HintPlanDebugQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HintPlanDebugQuery,
    HintPlanDebugQueryVariables
  >(HintPlanDebugDocument, options);
}
export type HintPlanDebugQueryHookResult = ReturnType<
  typeof useHintPlanDebugQuery
>;
export type HintPlanDebugLazyQueryHookResult = ReturnType<
  typeof useHintPlanDebugLazyQuery
>;
export type HintPlanDebugSuspenseQueryHookResult = ReturnType<
  typeof useHintPlanDebugSuspenseQuery
>;
export type HintPlanDebugQueryResult = Apollo.QueryResult<
  HintPlanDebugQuery,
  HintPlanDebugQueryVariables
>;
